<script setup>
import {reactive, onMounted} from "vue";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {ToastUtil} from "@/Utils/ToastUtil";

const data = reactive({
  open: 0,
  cycle: 0,
  closed: 0,
  received: 0,
  review: 0
});

onMounted(()=>{
  ApiWrapper.get('finance-stats', 'finance-stats')
  .then((response) => {
    if(response.financeStats){
      data.open = response.financeStats[0].open;
      data.cycle = response.financeStats[0].cycle;
      data.closed = response.financeStats[0].closed;
      data.received = response.financeStats[0].received;
      data.review = response.financeStats[0].review;
    }
  })
  .catch((error)=>{
    ToastUtil.error(error);
  })
})
</script>

<template>
  <v-container  fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Finance Stats</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row density="compact" justify="space-between">
        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.open}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Open Claims
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.cycle}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Average Cycle Time
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.closed}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Closed 24 Hours
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.received}}</h1>
          <p style="text-align: center; vertical-align: bottom">
            Received 24 Hours
          </p>
        </v-col>

        <v-col cols="12" sm="2">
          <h1 style="text-align: center">{{data.review}}</h1>
          <p style="text-align: center">In Review</p>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
.container {
  padding: 5px;
}
[v-cloak] {
  display: none;
}
</style>